<script setup lang="ts">
import { UIAvatar } from '@gohighlevel/ghl-ui';
import { getInitials } from '../../utils/generalFunctions';
import Tooltip from '../common/Tooltip.vue';
const props = defineProps<{
  teamMembers: any[]
}>()
</script>

<script lang="ts">
export default {
  name: 'SchedulePicker',
}
</script>

<template>
  <div>
    <div class="flex items-center gap-1">
    <div class="text-[14px] text-gray-700 font-medium">
      {{ $t('create_calendar.booking_availability') }}
    </div>
    <Tooltip :message="$t('calendar_advanced.availability.scheduling_availability_tooltip')" />
    </div>
    <div class="grid grid-cols-1 gap-x-2 gap-y-3 bg-white py-3 sm:grid-cols-2">
      <div
        v-for="member in props.teamMembers.slice(0, 4)"
        :key="member.userId"
        type="button"
        class="group flex w-full flex-row items-center gap-3 rounded-lg border bg-white px-3 py-2 transition-all duration-150 focus:outline-none"
        :class="['border-gray-300', 'hover:shadow']"
      >
        <div
          class="flex h-10 w-10 flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-100"
        >
          <UIAvatar
            v-if="member?.profilePhoto"
            :src="member.profilePhoto"
            :alt="member.name"
            class="h-10 w-10"
          />
          <span v-else class="text-base font-normal text-gray-700">
            {{ getInitials(member?.name) }}
          </span>
        </div>
        <div
          class="flex min-w-0 flex-1 flex-col items-start justify-center gap-1"
        >
          <span
            class="w-full truncate text-left text-sm font-normal leading-tight text-gray-700 transition-colors duration-150"
            :title="member.name"
          >
            {{ member.name }}
          </span>
          <span class="text-xs text-gray-500">
            {{ member.availabilityText }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
